document.addEventListener('DOMContentLoaded', (event) => {
    const readMoreButton = document.querySelector('#custom_text_hidden .woocommerce-button');

    const hiddenText = document.querySelector('.hidden-text');

    readMoreButton.addEventListener('click', () => {
        if (hiddenText.style.display === 'none' || hiddenText.style.display === '') {
            hiddenText.style.display = 'block';
            readMoreButton.textContent = 'Czytaj mniej';
        } else {
            hiddenText.style.display = 'none';
            readMoreButton.textContent = 'Czytaj więcej';
        }
    });
});

jQuery(document).ready(function ($) {

    $('.navbar-nav > .nav-item.has-dropdown').hover(
        function () {
            $(this).children('.dropdown-menu').stop(true, true).slideDown('fast');
        },
        function () {
            $(this).children('.dropdown-menu').stop(true, true).slideUp('fast');
        }
    );

});

jQuery(document).ready(function ($) {
    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.mobile-navbar-nav').slideToggle('fast');
    });


    $('.mobile-dropdown-arrow').click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).parent().siblings('.mobile-dropdown-menu').slideToggle('fast');
    });

    $(document).click(function (event) {
        if (!$(event.target).closest('.mobile-custom-navbar').length && !$(event.target).is('.navbar-toggler')) {
            $('.mobile-navbar-nav').slideUp('fast');
        }
    });
});

jQuery(document).ready(function ($) {


    var style = $('<style>.bapf_slidr_all { opacity: 1 !important; }</style>');
    $('head').append(style);

})


document.addEventListener('DOMContentLoaded', function () {
    var urlField = document.querySelector('input[name=aktualna-strona]');
    if (urlField) {
        urlField.value = window.location.href;
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const paginationContainer = document.querySelector('.woocommerce-pagination');
    if (paginationContainer) {
        paginationContainer.addEventListener('click', function (e) {
            if (e.target.tagName === 'A') {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    }
});